var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FocusLayout',{attrs:{"title":_vm.$t('Welcome back'),"subtitle":_vm.$t('Please sign in to continue')}},[_c('LoginForm',_vm._b({on:{"authenticated":function($event){return _vm.$router.push({ name: 'home' })}}},'LoginForm',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }